import {Box, Typography, Link} from "@mui/material";
import LaptopIcon from '@mui/icons-material/Laptop';

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                mt: "auto",
                py: 1,
                textAlign: "center",
                borderTop: "1px solid",
                borderColor: "divider",
            }}
        >
            <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 0.5,
                    flexWrap: "wrap"
                }}
            >
                <span>© {new Date().getFullYear()} Aventură și Călătorii SRL</span>
                <Box sx={{display: "flex", alignItems: "center", gap: 0.5}}>
                    <LaptopIcon sx={{fontSize: "1.2rem", marginLeft: "12px", marginRight: '2px'}}/>
                    <span>developer:</span>
                    <Link
                        href="https://cristian.hilohi.dev"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Cristian Hilohi
                    </Link>
                </Box>
            </Typography>
        </Box>
    );
};

export default Footer;